import React from 'react';
import styles from './ProductCard.module.css';

const ProductCard = (props) => {
    return (
        <div className={styles.productCard}>
            <div
                role="group"
                aria-label={props.ariaLabel}
                className={styles.cardContainer}
            >
                {/* Image Section */}
                <a href={props.productUrl} className={styles.imageLink}>
                    <div className={styles.imageSection}>
                        <div className={styles.imageContainer}>
                            <div className={styles.imageWrapper}>
                                <img
                                    src={props.imageUrl}
                                    alt={props.imageAlt}
                                    className={styles.productImage}
                                />
                            </div>
                            <button className={styles.quickViewButton}>
                                Request
                            </button>
                        </div>
                        <div className={styles.categoryBadge}>
                            {props.categoryLabel}
                        </div>
                    </div>
                </a>

                {/* Info Section */}
                <div className={styles.infoSection}>
                    <a href={props.productUrl} className={styles.infoLink}>
                        <div className={styles.productName}>
                            {props.productName}
                        </div>
                        <div className={styles.price}>
                            {props.price}
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;